import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import config from '../config';
import Notification from '../components/Notification';
import LoadingSpinner from '../components/LoadingSpinner';
import '../styles/register.css';

const ResetPassword = () => {
    const { userId } = useParams();
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [notification, setNotification] = useState({ message: '', type: 'success', header: '' });
    const [errors, setErrors] = useState({});
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const navigate = useNavigate();

    const validatePassword = (password) => {
        const passwordRegex = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{6,}$/;
        return passwordRegex.test(password);
    };

    const handlePasswordChange = (e) => {
        const value = e.target.value;
        setPassword(value);
        if (!validatePassword(value)) {
            setErrors((prevErrors) => ({
                ...prevErrors,
                password: 'Min 6 caractères avec lettres et chiffres',
            }));
        } else {
            setErrors((prevErrors) => {
                const { password, ...rest } = prevErrors;
                return rest;
            });
        }
    };

    const handleConfirmPasswordChange = (e) => {
        const value = e.target.value;
        setConfirmPassword(value);
        if (value !== password) {
            setErrors((prevErrors) => ({
                ...prevErrors,
                confirmPassword: 'Les mots de passe ne correspondent pas.',
            }));
        } else {
            setErrors((prevErrors) => {
                const { confirmPassword, ...rest } = prevErrors;
                return rest;
            });
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (password !== confirmPassword) {
            setNotification({ message: 'Les mots de passe ne correspondent pas.', type: 'error', header: 'Erreur' });
            return;
        }

        if (!validatePassword(password)) {
            setNotification({ message: 'Min 6 caractères avec lettres et chiffres', type: 'error', header: 'Erreur' });
            return;
        }

        setIsSubmitting(true);
        try {
            const response = await fetch(`${config.backendUrl}/users/reset-password/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ user_id: userId, password: password }),
            });
            if (response.status === 200) {
                setNotification({ message: 'Mot de passe réinitialisé avec succès.', type: 'success', header: 'Succès' });
                setTimeout(() => {
                    navigate('/login');
                }, 3000);
            } else {
                setNotification({ message: 'Échec de la réinitialisation du mot de passe.', type: 'error', header: 'Erreur' });
            }
        } catch (error) {
            setNotification({ message: 'Une erreur est survenue. Veuillez réessayer.', type: 'error', header: 'Erreur' });

        } finally {
            setIsSubmitting(false);
        }
    };

    const isFormValid = validatePassword(password) && password === confirmPassword;

    return (
        <div className="modern-auth-page">
            {notification.message && (
                <Notification
                    message={notification.message}
                    type={notification.type}
                    header={notification.header}
                    onClose={() => setNotification({ message: '', type: 'success', header: '' })}
                />
            )}
            <div className="register-card">
                <h2 className="register-title">Réinitialiser le mot de passe</h2>
                <form className="register-form" onSubmit={handleSubmit}>
                    <div className="input-group">
                        <div className="input-container">
                            <input
                                type={showPassword ? 'text' : 'password'}
                                name="password"
                                placeholder={errors.password ? '' : 'Nouveau mot de passe'}
                                value={password}
                                onChange={handlePasswordChange}
                                className={`input ${errors.password ? 'input-error' : ''} ${!errors.password && password ? 'input-valid' : ''}`}
                                required
                            />
                            <button
                                type="button"
                                onClick={() => setShowPassword(!showPassword)}
                                className="password-toggle"
                            >
                                {showPassword ? '👁️' : '👁️‍🗨️'}
                            </button>
                        </div>
                        {errors.password ? (
                            <p className="reset-password-error-message">{errors.password}</p>
                        ) : (
                            <p className="password-rule">Min 6 caractères avec lettres et chiffres</p>
                        )}
                    </div>
                    <div className="input-group">
                        <div className="input-container">
                            <input
                                type={showConfirmPassword ? 'text' : 'password'}
                                name="confirmPassword"
                                placeholder={errors.confirmPassword ? '' : 'Confirmer le mot de passe'}
                                value={confirmPassword}
                                onChange={handleConfirmPasswordChange}
                                className={`input ${errors.confirmPassword ? 'input-error' : ''} ${!errors.confirmPassword && confirmPassword && password === confirmPassword ? 'input-valid' : ''}`}
                                required
                            />
                            <button
                                type="button"
                                onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                                className="password-toggle"
                            >
                                {showConfirmPassword ? '👁️' : '👁️‍🗨️'}
                            </button>
                        </div>
                        {errors.confirmPassword && <p className="reset-password-error-message">{errors.confirmPassword}</p>}
                    </div>
                    <button
                        type="submit"
                        className={`register-button ${isSubmitting || !isFormValid ? 'button-disabled' : ''}`}
                        disabled={isSubmitting || !isFormValid}
                    >
                        {isSubmitting ? 'Envoi en cours...' : 'Réinitialiser le mot de passe'}
                    </button>
                </form>
                {isSubmitting && (
                    <div className="modal-background">
                        <div className="modal-content">
                            <LoadingSpinner />
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default ResetPassword;
